import FusePageSimple from '@fuse/core/FusePageSimple';
import { useTheme } from '@mui/material/styles';
import Hidden from '@mui/material/Hidden';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import withReducer from 'app/store/withReducer';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { useDeepCompareEffect } from '@fuse/hooks';
import SwipeableViews from 'react-swipeable-views';
import { ListItem, ListItemButton, ListItemText, Step, StepContent, StepLabel } from '@mui/material';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import useThemeMediaQuery from '@fuse/hooks/useThemeMediaQuery';
import reducer from '../store';
import { getCourse, selectCourse, updateCourse } from '../store/courseSlice';
import CourseInfo from '../CourseInfo';
import CourseProgress from '../CourseProgress';
import CourseInfoSignUp from '../CourseInfoSignUp';
import { List } from 'immutable';

function CourseSignUp(props) {
  const dispatch = useDispatch();
  const course = useSelector(selectCourse);
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));
  const theme = useTheme();
  const [leftSidebarOpen, setLeftSidebarOpen] = useState(!isMobile);
  const routeParams = useParams();
  const { courseId } = routeParams;
  const pageLayout = useRef(null);

  const [certificates, setCertificates] = useState([
    {
      id: 1,
      title: "Atualizar seu Currículo, aumentando suas chances para conquistar um bom emprego;"
    },
    {
      id: 2,
      title: "Aumentar suas chances de promoção no emprego (atual);"
    },
    {
      id: 3,
      title: "Completar horas em atividades Extracurriculares (geralmente exigidas em Faculdades);"
    },
    {
      id: 4,
      title: "Progressão Funcional para Servidores Públicos;"
    },
    {
      id: 5,
      title: "Pré-Requisito para concursos e cursos."
    }


  ]);

  useDeepCompareEffect(() => {
    /**
     * Get the Course Data
     */
    dispatch(getCourse(courseId));
  }, [dispatch, routeParams]);

  useEffect(() => {
    /**
     * If the course is opened for the first time
     * Change ActiveStep to 1
     */
    if (course && course.progress.currentStep === 0) {
      dispatch(updateCourse({ progress: { currentStep: 1 } }));
    }
  }, [dispatch, course]);

  useEffect(() => {
    setLeftSidebarOpen(!isMobile);
  }, [isMobile]);


  if (!course) {
    return null;
  }

  const { currentStep } = course.progress;

  const activeStep = currentStep !== 0 ? currentStep : 1;

  return (
    <FusePageSimple
      content={
        <div className="w-full">

          <div className="p-32">
            <Button
              to="/apps/academy/courses"
              component={Link}
              className="mb-24"
              color="secondary"
              variant="text"
              startIcon={
                <FuseSvgIcon size={20}>
                  {theme.direction === 'ltr'
                    ? 'heroicons-outline:arrow-sm-left'
                    : 'heroicons-outline:arrow-sm-right'}
                </FuseSvgIcon>
              }
            >
              Voltar aos cursos
            </Button>

            <Typography className="text-16 font-medium">{course.title}</Typography>
            <Typography className="text-13 mt-2 line-clamp-2" color="text.secondary">
              {course.description}
            </Typography>
            <Typography className="flex items-center space-x-6 text-13" color="text.secondary">
              <FuseSvgIcon color="disabled" size={20}>
                heroicons-solid:clock
              </FuseSvgIcon>
              <span className="whitespace-nowrap leading-none">{`${course.duration} minutos`}</span>
            </Typography>

          </div>

          <div className="p-16">
            <Button
              to="/sign-in"
              component={Link}
              className="px-16 min-w-128 center"
              color="secondary"
              variant="contained"
              endIcon={
                <FuseSvgIcon className="" size={20}>
                  heroicons-solid:arrow-sm-right
                </FuseSvgIcon>
              }
            >
              Inscreva-se grátis
            </Button>
          </div>

          <Divider />

          <Stepper classes={{ root: 'p-32' }} activeStep={activeStep} orientation="vertical">
            {course.steps.map((step, index) => {
              return (
                <Step
                  key={index}
                  sx={{
                    '& .MuiStepLabel-root, & .MuiStepContent-root': {
                      cursor: 'pointer!important',
                    },
                    '& .MuiStepContent-root': {
                      color: 'text.secondary',
                      fontSize: 13,
                    },
                  }}
                  expanded
                >
                  <StepLabel
                    className="font-medium"
                    sx={{
                      '& .MuiSvgIcon-root': {
                        color: 'background.default',
                        '& .MuiStepIcon-text': {
                          fill: (_theme) => _theme.palette.text.secondary,
                        },
                        '&.Mui-completed': {
                          color: 'secondary.main',
                          '& .MuiStepIcon-text ': {
                            fill: (_theme) => _theme.palette.secondary.contrastText,
                          },
                        },
                        '&.Mui-active': {
                          color: 'secondary.main',
                          '& .MuiStepIcon-text ': {
                            fill: (_theme) => _theme.palette.secondary.contrastText,
                          },
                        },
                      },
                    }}
                  >
                    {step.title}
                  </StepLabel>
                  <StepContent>{step.subtitle}</StepContent>
                </Step>
              );
            })}
          </Stepper>

          <Typography className="text-13 mt-2 line-clamp-2" color="text.secondary">
            5 Vantagens do Certificado:
          </Typography>

          <Stepper classes={{ root: 'p-32' }} activeStep={-1} orientation="vertical">
            {certificates.map((step, index) => {
              return (
                <Step
                  key={index}
                >
                  <StepLabel
                    className="font-medium"
                  >
                    {step.title}
                  </StepLabel>
                </Step>
              );
            })}
          </Stepper>
        </div>
      }

      scroll="content"
      ref={pageLayout}
    />
  );
}

export default withReducer('academyApp', reducer)(CourseSignUp);
